import { message } from "antd";
import { convertDateToLocale, getIngredientUnitLabel } from "./inventory.service";
import { getParsedNumber } from "../../utils/Common";

export function validatePurchaseItems(purchaseItems) {
  if (purchaseItems.length < 1) {
    message.warning(
      <p className="font-p_regular text-[12px] px-5">
        You need at least one item to save purchase item!
        <br />
        Please add your purchase item{" "}
        <span className="text-red-500">name, quantity, unit price, carriage inwards, purchase date </span>and select
        your <span className="text-red-500">supplier</span>.
      </p>
    );
    return false;
  }

  for (let idx = 0; idx < purchaseItems.length; idx++) {
    const purchaseItem = purchaseItems[idx];
    if (!purchaseItem.ingredientId || purchaseItem.ingredientId === "") {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Oops! Looks like you forgot to pick an item <span className="text-red-500">name</span>! For {idx+1} no item.
        </p>
      );
      return false;
    }
    if (getParsedNumber(purchaseItem.quantity) === 0) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Please enter item <span className="text-red-500">quantity</span>! For {idx+1} no item.
        </p>
      );
      return false;
    }
    if (getParsedNumber(purchaseItem.unitPrice) === 0) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Please enter item <span className="text-red-500">unit price</span>! For {idx+1} no item.
        </p>
      );
      return false;
    }
    if (Number(purchaseItem.unitPrice) < 0) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Item <span className="text-red-500">unit price</span> can not less than zero! For {idx+1} no item.
        </p>
      );
      return false;
    }
    if (purchaseItem.purchaseDate === "") {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Please select item <span className="text-red-500">purchase date</span>! For {idx+1} no item.
        </p>
      );
      return false;
    }
  }

  return true;
}

export function preparePurchaseReport(reports) {
  if (!Array.isArray(reports) || reports.length < 1) return [];
  return [
    ...reports.map((report) => ({
      id: report.id,
      itemName: report.ingredient.name,
      qty: report.quantity + " " + getIngredientUnitLabel(report.ingredient.unit),
      unitPrice: report.unitPrice + " TK",
      totalPrice: report.totalPrice + " TK",
      supplier: report?.supplier?.name || '',
      entryDate: convertDateToLocale(report.entryDate),
      carriageInwards: report.carriageInwards,
      purchaseDate: convertDateToLocale(report.purchaseDate),
    })),
  ];
}


export function formatSummaryData(obj) {
  return Object.entries(obj).map(([key, value]) => ({
    title: key
      .replace(/([A-Z])/g, " $1") // add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()), // capitalize first letter
    amount: value,
  }));
}